import { useEffect, useState } from "react";
import api from "../services/api";

// What MyEduGenius knows about the signed-in student (focus areas, a personal greeting).
// Shared by the dashboard, the tutor and the quiz page; cached briefly and per sign-in so switching
// accounts never shows another student's data.
let cache = { at: 0, key: "", data: null, pending: null };
const TTL = 60 * 1000;

const tokenKey = () =>
  localStorage.getItem("access_token") || sessionStorage.getItem("access_token") || "";

export const loadSnapshot = async (force = false) => {
  const key = tokenKey().slice(-24);
  if (!key) return null;
  if (!force && cache.key === key && cache.data && Date.now() - cache.at < TTL) return cache.data;
  if (cache.pending && cache.key === key) return cache.pending;
  cache = { ...cache, key, pending: null };
  const request = api
    .get("/api/learner/profile")
    .then((res) => {
      cache = { at: Date.now(), key, data: res.data, pending: null };
      return res.data;
    })
    .catch(() => {
      cache = { ...cache, pending: null };
      return null;
    });
  cache.pending = request;
  return request;
};

export default function useLearnerSnapshot() {
  const [snapshot, setSnapshot] = useState(() => {
    const key = tokenKey().slice(-24);
    return cache.key === key ? cache.data : null;
  });
  useEffect(() => {
    let cancelled = false;
    loadSnapshot().then((data) => {
      if (!cancelled && data) setSnapshot(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return { snapshot };
}
